export default (x, f) => f(x)
